import { render, staticRenderFns } from "./CertificadosList.html?vue&type=template&id=01ae6c8a&scoped=true&external"
import script from "./CertificadosList.vue?vue&type=script&lang=js"
export * from "./CertificadosList.vue?vue&type=script&lang=js"
import style0 from "./CertificadosList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ae6c8a",
  null
  
)

export default component.exports